import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import burgerMenu from '../assets/burgermenu.png';
import './header.css';

export default function Header({ menuOpen, onOpen, triggerRef, inert }) {
  return (
    <header className="header" inert={inert ? true : undefined}>
      <Link className="header__logo" to="/" aria-label="Zeina home">
        <img src={logo} alt="Zeina" width="118" height="24" />
      </Link>
      <button
        className="header__menu-button"
        type="button"
        ref={triggerRef}
        aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
        aria-expanded={menuOpen}
        aria-haspopup="dialog"
        aria-controls={menuOpen ? 'header-navigation' : undefined}
        onClick={onOpen}
      >
        <img src={burgerMenu} alt="" width="40" height="28" />
      </button>
    </header>
  );
}
